import Header from "./Header";
import Footer from "./Footer";
import VoucherCode from "../../../../components/VoucherCode";
import "./Container.scss";
import "./VoucherCode.scss";

const Container = ({ product }) => {
  return (
    <>
      <section className="redemption-code-container template-vero">
        <Header product={product} />
        <div className="redemption-code-content row justify-content-center">
          <div className="card redemption-code-card-top">
            <div className="card-body">
              <div className="row">
                <div className="col-sm-4">
                  <div className="voucher-image-redemption-code">
                    <img
                      src={product.image?.medium || product.image?.original}
                      alt={product.name}
                    />
                  </div>
                </div>
                <div className="col-sm-8 align-self-center">
                  <p className="voucher-name">{product.name}</p>
                  <p className="voucher-price">{product.productDescription}</p>
                </div>
              </div>
              <VoucherCode
                code={product.codes.voucherCode}
                pin={product.codes.voucherPinCode}
                merchantId={product.merchantId}
                link={product.codes.link}
                showCodeMessage="Ver meu código"
              />
            </div>
          </div>
        </div>
        <Footer />
      </section>
    </>
  );
};

export default Container;
